import { defineRouting } from 'next-intl/routing'
import { getDefaultLocale, getLocales } from '@/utils/routing'

export const routing = defineRouting({
  locales: getLocales(),
  defaultLocale: getDefaultLocale(),
})
